import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72c2d534"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "app-input__wrapper" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "app-input__append"
}
const _hoisted_6 = {
  key: 1,
  class: "app-input__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-input", _ctx.separatedAttrs.wrapperClasses])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "app-input__label",
          for: _ctx.inputId
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" * ")
              ], 64))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$slots.prepend !== undefined)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "app-input__prepend",
            for: _ctx.inputId
          }, [
            _renderSlot(_ctx.$slots, "prepend", {}, undefined, true)
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", _mergeProps({
        id: _ctx.inputId,
        ref: "inputRef",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        class: ['app-input__field', _ctx.inputClasses],
        type: "text"
      }, _ctx.separatedAttrs.inputAttrs, {
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur', $event.target.value)))
      }), null, 16, _hoisted_4), [
        [_vModelText, _ctx.inputValue]
      ]),
      (_ctx.$slots.append !== undefined || _ctx.clearable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.clearable && _ctx.hasValue)
              ? (_openBlock(), _createBlock(_component_IconButton, {
                  key: 0,
                  onClick: _ctx.clearValue
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseIcon)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _renderSlot(_ctx.$slots, "append", { key: 1 }, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isError && _ctx.errorText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errorText), 1))
      : _createCommentVNode("", true)
  ], 2))
}